// extracted by mini-css-extract-plugin
export default {"textarea":"CreateMsgTextarea_textarea__rUgm5"};